import { render, staticRenderFns } from "./List.vue?vue&type=template&id=dd6fa538&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=dd6fa538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6fa538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd6fa538')) {
      api.createRecord('dd6fa538', component.options)
    } else {
      api.reload('dd6fa538', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=dd6fa538&scoped=true&", function () {
      api.rerender('dd6fa538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/winner/List.vue"
export default component.exports